// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"af2fa2e7","3671":"588214af","4529":"6ec9b712","5707":"23e561d8","7101":"06788527","7403":"b6ce730b","7427":"d7280407","8291":"d30bda86","9715":"9ea24ca9","9925":"1abb2d5d"}[chunkId] + ".chunk.css";
};